module.exports = __webpack_public_path__ + "static/media/paypal-logo.fb039762.png";